import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

function mapsApiKey(): string {
	return (environment as any).googleMapsApiKey
		|| (environment as any).googleApiKey
		|| '';
}

function ensureGoogleMapsLoaded(): Promise<void> {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return Promise.resolve();
	}

	const key = mapsApiKey();
	if (!key) {
		return Promise.resolve();
	}

	const w = window as any;
	if (w.google?.maps?.places) {
		return Promise.resolve();
	}

	const existing = document.querySelector<HTMLScriptElement>(
		'script[src*="maps.googleapis.com/maps/api/js"]',
	);
	if (existing) {
		return new Promise((resolve) => {
			if (w.google?.maps) {
				resolve();
				return;
			}
			existing.addEventListener('load', () => resolve(), {once: true});
			existing.addEventListener('error', () => resolve(), {once: true});
		});
	}

	return new Promise((resolve) => {
		const s = document.createElement('script');
		s.async = true;
		s.defer = true;
		s.setAttribute('data-credilow-maps-bootstrap', '1');
		s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places`;
		s.addEventListener('load', () => resolve(), {once: true});
		s.addEventListener('error', () => resolve(), {once: true});
		document.head.appendChild(s);
	});
}

function bootstrapApp(): void {
	platformBrowserDynamic()
		.bootstrapModule(AppModule)
		.catch((err) => console.error(err));
}

if (environment.production) {
	enableProdMode();
}

ensureGoogleMapsLoaded().then(bootstrapApp, bootstrapApp);
